import { C43MediaGalleryItemProps } from './C43MediaGalleryItem.types';
import { MediaItem } from '@ahc-digital/component-library';
import { getCheckbox } from 'src/shared/param-utils';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';

export function GetMediaGalleryItemModel(
  props?: Pick<C43MediaGalleryItemProps, 'fields'>,
  shouldLazyLoad?: string | undefined
): MediaItem {
  const { renderText, renderRichText, renderImage } = useConditionalRendering();
  const { fields } = props || {};
  const slide: MediaItem = {
    image: renderImage(fields?.Image),
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    videoId: fields?.VideoID?.value,
    videoIdField: renderText(fields?.VideoID),
    shouldLazyLoad: getCheckbox(shouldLazyLoad),
  };
  return slide;
}
